import { useCallback } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { openUploadDialogAtom, uploadFileDescriptorsAtom, kpkMediaImportsAtom, kpkMediaImportsProgressAtom } from '../atoms.js';
import { kpkMediaImportsSelector, importStatusSelector } from '../selectors.js';

/**
 * Use upload for views. It will be triggered while adding new files and while upload queue is empty.
 * This hook can be called anywhere because it won't be triggered during file upload progress: take a lot of care modifying this hook.
 */
var useUpload = function (uploadKey) {
    var kpkMediaImports = useRecoilValue(kpkMediaImportsSelector(uploadKey));
    var uploadStatus = useRecoilValue(importStatusSelector(uploadKey));
    var openUploadDialog = useRecoilValue(openUploadDialogAtom(uploadKey));
    var setUploadFileDescriptor = useSetRecoilState(uploadFileDescriptorsAtom(uploadKey));
    var setKpkMediaImportsAtom = useSetRecoilState(kpkMediaImportsAtom(uploadKey));
    var setKpkMediaImportsProgressAtom = useSetRecoilState(kpkMediaImportsProgressAtom(uploadKey));
    var uploadEnded = useCallback(function () {
        setUploadFileDescriptor(function (uploadFileDescriptors) {
            // Clear descriptor refresh, not needed anymore. Do this while setting empty array
            // to not trigger any update in render loop.
            uploadFileDescriptors.forEach(function (uploadFileDescriptor) {
                if (uploadFileDescriptor.descriptorRefreshInterval) {
                    clearInterval(uploadFileDescriptor.descriptorRefreshInterval);
                    console.debug("Descriptor ".concat(uploadFileDescriptor.descriptorId, " refresh disabled"));
                }
            });
            return [];
        });
        setKpkMediaImportsAtom([]);
        setKpkMediaImportsProgressAtom([]);
    }, [setKpkMediaImportsAtom, setKpkMediaImportsProgressAtom, setUploadFileDescriptor]);
    return {
        kpkMediaImports: kpkMediaImports,
        uploadStatus: uploadStatus,
        openUploadDialog: openUploadDialog,
        uploadEnded: uploadEnded
    };
};

export { useUpload };
//# sourceMappingURL=useUpload.js.map
